import { isObject, concatObjects, matchObjectTypes } from './utils'
import App from './App.svelte'

export default function initializeXoCustomAlbum({ root, id, options, widget_type } = {}) {
  if (!root || !(root instanceof HTMLElement)) {
    throw new Error('Root node is not valid')
  }
  if (!id) {
    throw new Error('Invalid albumId')
  }

  let app = new App({
    target: root,
    props: {
      albumId: id,
      config: applyDefaultOptions(options),
      widget_type
    },
  })

  return app
}

if (__DEV__) {
  /* eslint-disable no-inner-declarations */
  function setupGalleries() {
    let shopHandle = window._shop.handle

    let albums = Array.from(
      document.querySelectorAll(`.xo-album[data-shop="${shopHandle}"]`)
    ).filter(x => x.getAttribute('data-id'))

    const filterKeys = ['Make', 'Model', 'Wheel']

    let instances = albums.map(node =>
      initializeXoCustomAlbum({
        widget_type: 'v2',
        root: node,
        id: node.getAttribute('data-id'),
        options: {
          // shopHandle: 'velgen-wheels',
          shopHandle: window._shop.handle,
          perPage: 8,
          updateUrl: albums.length === 1,
          resetScrollOnPaginate: false,
          resetScrollOnGallerySelect: false,
          // baseUrl: 'https://www.velgenwheels.com',
          baseUrl: window._shop.url,
          album: {
            cssClass: '',
            filterSectionHeading: 'Quick Lookup',
            filterKeys: filterKeys,
            _createFilter: albumItem => {
              let title = albumItem.title.toLowerCase()
              let brands = ['BMW', 'Dodge', 'Forde', 'Jeep', 'McLaren', 'Ford']
              let filters = { Make: '<NA>', Year: '<NA>' }

              brands.some(b => {
                let matched = title.includes(b.toLowerCase())
                if (matched) {
                  filters['Make'] = b
                }
                return matched
              })

              let [year] = title.match(/\d{4}/) || []
              if (year) {
                filters['Year'] = year
              }

              return filters
            },
            createFilter: albumItem => {
              if (albumItem.title.trim()[0] !== '[') {
                return
              }

              let titleParts = albumItem.title.split(']')
              let titleMeta = titleParts[0].replace('[', '').trim().split(',').map(x => x.trim())
              let title = titleParts[1]
              albumItem.title = `${titleMeta.join(' ')} ${title}`

              // titleMeta is in this format: [MAKE, MODEL TRIM, PRODUCT]
              // remove the TRIM from MODEL
              let model = titleMeta[1].split(' ')[0]


              let filters = filterKeys.reduce((acc, key, index) => {
                acc[key] = titleMeta[index]

                // if `model`, then remove the trim
                if (index === 1) {
                  acc[key] = model
                }
                return acc
              }, {})

              return filters
            }
          },
          gallery: {
            cssClass: '',
            thumbCssClass: '',
            goBackCssClass: 'btn',
            detailsText: 'Wheel Details',
            viewProductsText: 'View Products'
          },
          onEvent: (ev, data) => {
            console.log(ev, data)
            if (ev === 'BACK_TO_ALBUM') {
              setTimeout(() => {
                document.body.scrollIntoView({ behavior: 'smooth' })
                console.log('reset scroll')
              }, 20)
            }
          },
        },
      })
    )
  }

  document.addEventListener('DOMContentLoaded', setupGalleries)
}
// -----------------

function applyDefaultOptions(options) {
  let defaultProps = {
    shopHandle: window.Shopify?.shop?.split('.')[0],
    perPage: 8,
    updateUrl: false,
    resetScrollOnPaginate: true,
    resetScrollOnGallerySelect: true,
    baseUrl: '',
    album: {
      cssClass: '',
      filterSectionHeading: 'Filter',
      filterKeys: [],
      createFilter: albumJson => {
        return null
      },
    },
    gallery: {
      cssClass: '',
      thumbCssClass: '',
      goBackCssClass: '',
      detailsText: 'Details',
    },
    onEvent: () => {},
  }

  // ---------------------------

  const shopHandle = defaultProps.shopHandle || options.shopHandle
  if (typeof shopHandle !== 'string') {
    throw new Error('Missing `shopHandle` prop')
  }

  defaultProps.shopHandle = options.shopHandle = shopHandle

  if (!isObject(options)) {
    return { ...defaultProps }
  }

  options.perPage = Math.trunc(options.perPage || defaultProps.perPage)
  if (typeof options.perPage !== 'number' || options.perPage < 1)
    options.perPage = defaultProps.perPage

  if (typeof options.baseUrl !== 'string')
    options.baseUrl = defaultProps.baseUrl
  if (typeof options.updateUrl !== 'boolean')
    options.updateUrl = defaultProps.updateUrl
  if (typeof options.resetScrollOnPaginate !== 'boolean')
    options.resetScrollOnPaginate = defaultProps.resetScrollOnPaginate
  if (typeof options.resetScrollOnGallerySelect !== 'boolean')
    options.resetScrollOnGallerySelect = defaultProps.resetScrollOnGallerySelect

  if (!isObject(options.album)) {
    options.album = { ...defaultProps.album }
  }

  if (!isObject(options.gallery)) {
    options.gallery = { ...defaultProps.gallery }
  }

  options.album = matchObjectTypes(
    defaultProps.album,
    concatObjects(defaultProps.album, options.album)
  )

  options.gallery = matchObjectTypes(
    defaultProps.gallery,
    concatObjects(defaultProps.gallery, options.gallery)
  )

  if (typeof options.onEvent !== 'function')
    options.onEvent = defaultProps.onEvent

  return options
}
